import { limeApiGet } from "./api";
import { AuthContextProps } from "react-oidc-context";

export class FeatureFlagsResult {
    newVgpEnabled: boolean;
    liviVgpEnabled: boolean;

    constructor(NewVgpEnabled: boolean = false, LiviVgpEnabled: boolean = false) {
        this.newVgpEnabled = NewVgpEnabled;
        this.liviVgpEnabled = LiviVgpEnabled;
    }
}

export async function getFeatureFlag(auth: AuthContextProps){
    if (!auth.isLoading && auth.isAuthenticated) {
        return await limeApiGet<FeatureFlagsResult>(`feature`, auth);
    }
    return new FeatureFlagsResult();
}